import React from 'react';

import { Flex, FormControl, FormErrorMessage, FormLabel, Heading, Select } from '@chakra-ui/react';
import { Field, FieldProps } from 'formik';

import { CustomText } from '@components/Custom-text';

interface FormControlSelectFieldProps {
    name: string;
    label: string;
    placeholder: string;
    options: { key: string; value: string }[];
    size?: string;
    isRequired?: boolean;
    isDisabled?: boolean;
}

const FormControlSelectField: React.FC<FormControlSelectFieldProps> = ({
    name,
    label,
    placeholder,
    options,
    size,
    isRequired,
    isDisabled,
}) => (
    <Field name={name}>
        {({ field, form: { touched, errors, values } }: FieldProps) => {
            const isInvalid = !!errors[field.name] && touched[field.name];
            return (
                <FormControl isInvalid={Boolean(isInvalid)}>
                    <Flex>
                        <FormLabel>
                            <Heading color="titleText" size="xs" as="h6">
                                {label}
                            </Heading>
                        </FormLabel>
                        {isRequired ? (
                            <Heading color="red" size="xs" ml={-2}>
                                *
                            </Heading>
                        ) : null}
                    </Flex>
                    <Select
                        {...field}
                        placeholder={placeholder}
                        color={values[name] === '' ? 'subText' : 'titleText'}
                        size={size ?? 'md'}
                        isDisabled={isDisabled}
                    >
                        {options?.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.key}
                            </option>
                        ))}
                    </Select>
                    <FormErrorMessage>
                        <CustomText size="xs" color="red.500">
                            {String(errors[field.name])}
                        </CustomText>
                    </FormErrorMessage>
                </FormControl>
            );
        }}
    </Field>
);

export default FormControlSelectField;
